import { UIComponentCSSStyleImpl, UIComponentCSSStyle } from '../../../../../../ui/toolkit/uicomponentcss';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export interface EnglishTransactionHistoryListCSSStyle extends UIComponentCSSStyle
{
    getTitleDivCSSStyle():object;
    getTimestampDivCSSStyle():object;
    getPriceDivCSSStyle():object;
    getDurationDivCSSStyle():object;
    getTransactionTypeDivCSSStyle():object;
    getChannelTypeDivCSSStyle():object;
    getTitleLabelCSSStyle():object;
    getTimestampLabelCSSStyle():object;
    getPriceLabelCSSStyle():object;
    getTransactionTypeLabelCSSStyle(type:string):object;
    getChannelTypeLabelCSSStyle():object;
   
}

export class  EnglishTransactionHistoryListCSSStyleImpl extends UIComponentCSSStyleImpl implements EnglishTransactionHistoryListCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
            width:'100%', 
            height:'100%', 
            flexFlow: "row wrap",
            display:'flex',
            flexDirection:'row',
            marginLeft:'4%',
            marginRight:'4%'
        };
    }

    getTitleDivCSSStyle():object
    {
        return{
            height:'20px', textAlign:'left',display:'flex'
            
        };
    }

    getTimestampDivCSSStyle():object
    {
        return{
            height:'20px', textAlign:'left',display:'flex' 
        };
    }

    getPriceDivCSSStyle():object
    {
        return{
            height:'20px',textAlign:'left',
        };
    }

    getDurationDivCSSStyle():object
    {
        return{
            height:'20px',textAlign:'left',

        };
    }
    getTransactionTypeDivCSSStyle():object
    {
        return{
            height:'20px',textAlign:'left',
        };
    }

    getChannelTypeDivCSSStyle():object
    {
        return{
            height:'20px', textAlign:'left',
        };
    }

    getTitleLabelCSSStyle():object
    {
        return{
            color:'#221E20',
             minWidth:'60px',
              margin:'30px 0px 30px 5px', 
              fontFamily:this.getResources().getFontFamily(), 
              letterSpacing:'0', 
              height:'20px',
              lineHeight:'20px',
              overflow: 'hidden',
              textOverflow: 'ellipsis', 
              fontSize:'15px'
        };
    }

    getTimestampLabelCSSStyle():object
    {
        return{
            color:'#221E20',
            minWidth: "60px", 
            margin:'30px 10px 30px 0px', 
            fontFamily:this.getResources().getFontFamily(), 
            letterSpacing:'0',
            height:'20px',
            lineHeight:'20px',
            overflow: 'hidden',
            textOverflow: 'ellipsis', 
            fontSize:'15px'
        };
    }

    getPriceLabelCSSStyle():object
    {
        return{
            minWidth:'30px',
             height:'20px',
             color:'#221E20',
             textAlign:'left', 
             margin:'30px 10px 30px 0px', 
             fontFamily:this.getResources().getFontFamily(), 
             letterSpacing:'0',
             lineHeight:'20px',
             fontSize:'15px',
             overflow: 'hidden',
             textOverflow: 'ellipsis',
        };
    }

    getTransactionTypeLabelCSSStyle(type:string):object
    {
        return{
            minWidth: "90px",
            height:'20px',
            color:type=== this.getContext().getResources().getString(Strings.Deactivated)?"#E21736":"#76B943",
            flex: 0.3,textAlign:'left', 
            margin:'30px 10px 30px 0px', 
            fontFamily:this.getResources().getFontFamily(), 
            letterSpacing:'0',
            lineHeight:'20px',
            fontSize:'15px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    }

    getChannelTypeLabelCSSStyle():object
    {
        return{
            color:'#221E20',
            minWidth:'40px',
            margin:'30px 0px 30px 0px',
            fontFamily:this.getResources().getFontFamily(),
             letterSpacing:'0', 
             height:'20px', 
             lineHeight:'20px',
             overflow: 'hidden',textOverflow: 'ellipsis', 
             fontSize:'15px'
        };
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/viewmodel/listcss/transactionhistorylistcss.tsx